// extracted by mini-css-extract-plugin
module.exports = {"tableContainer":"style_tableContainer__1lSUb","sectionHeader":"style_sectionHeader__2Grcd"};